<template>    
  <dialog-layout ref="addNoteDialog" :id="id" @click="dialogActions">        

      <h3 slot="headercontent">{{headertext}}?</h3>       
      <span>
        <p>
          <font color="green"><b>Notes restricted in length</b></font>
        </p>
        <p>
          <textarea cols="6" class="w3-input w3-border w3-validate" placeholder="short note" style="resize:none" min="0" max="250" maxlength="250" v-model="tempnote"/>
        </p>
        <large-button  v-if="tempnote" @click="ok()" class="w3-theme-action">Add Note</large-button>                           
      </span>

    </dialog-layout>
</template>


<script>

  export default {    
  props: {
    id: {
      type: String,      
      default:'AddNoteDialog'
    },
    headertext: {
      type: String,
      default:"Add Note"      
    },
    oktext: {
      type: String,
      default:"Yes"
    },
    usedefaultbutton: {
      type: Boolean,
      default:false
    }
  },  
  data: function() {
      return {        
        meta:null,
        tempnote:null
      }
    },
    methods: {  
      dialogActions(e){
        if(e.action==="canceldialog")
        {
          this.meta=null
          this.tempnote=null   
        }        
      },

      show(meta){
          this.meta=meta||null
          this.$refs.addNoteDialog.show()          
      },

      cancelDialog() {           
          this.$refs.addNoteDialog.cancelDialog()
      },      
      ok(){
          this.$emit("noteadded", {data:{meta:this.meta,note:this.tempnote}});            
          this.cancelDialog()
      }
    },  
    computed: {       
    }, 
    created(){        
    },
    mounted() {      
    }
  };
</script>
 
<style>
  .dialogcontent {
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/controls/AddNoteDialog.vue